import { AppState, Auth0Provider } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";

interface Auth0ProviderWithNavigateProps {
  children: React.ReactNode;
}

export const Auth0ProviderWithNavigate = ({
  children,
}: Auth0ProviderWithNavigateProps) => {
  const navigate = useNavigate();

  const domain = import.meta.env.ADMIN_AUTH0_DOMAIN;
  const clientId = import.meta.env.ADMIN_AUTH0_CLIENT_ID;
  const redirectUri = `${import.meta.env.ADMIN_URL}callback`;
  const audience = import.meta.env.ADMIN_API_ENDPOINT;

  const onRedirectCallback = (appState?: AppState) => {
    let redirectTo = `callback/${
      appState?.returnTo || window.location.pathname
    }`;
    // clean up the returnTo URL, replace // by /
    redirectTo = redirectTo.replace(/\/\//g, "/");
    navigate(redirectTo);
  };

  if (!(domain && clientId && redirectUri && audience)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience: audience,
        redirect_uri: redirectUri,
        scope: "openid profile email offline_access",
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage"
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};
